import * as React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Grid,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { BiHelpCircle } from "react-icons/bi";
import { MdLocalOffer } from "react-icons/md";
import "./infoStyle.css";

/**
 * The small "?" next to Promo Claim in the sidebar, and the dialog it opens.
 * Opens on click (not hover) so it works the same on touch devices.
 */
function PromoInfoModal() {
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();

  const handleClickOpen = (e) => {
    // The sidebar row underneath opens the promo claim modal — don't trigger it too.
    e.stopPropagation();
    setOpen(true);
  };

  const handleClose = (e) => {
    if (e) e.stopPropagation();
    setOpen(false);
  };

  return (
    <>
      <div
        onClick={handleClickOpen}
        style={{ display: "flex", cursor: "pointer", color: theme.palette.custom.blue }}
      >
        <BiHelpCircle size={16} />
      </div>

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="xs"
        id="infoModal"
        className="info-modal"
        BackdropProps={{
          style: {
            backdropFilter: "blur(5px)",
            backgroundColor: "rgba(0, 0, 0, 0.4)",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
          }}
        >
          <MdLocalOffer size={20} color={theme.palette.custom.blue} />
          <Typography variant="h6" component="h3" sx={{ flexGrow: 1 }}>
            How to get promo code
          </Typography>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{ color: theme.palette.grey[500] }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <hr />
        <DialogContent
          sx={{
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <div style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
                <MdLocalOffer
                  size={20}
                  color={theme.palette.custom.blue}
                  style={{ marginRight: 10 }}
                />
                <Typography variant="h6" sx={{ color: theme.palette.custom.blue }}>
                  Promo Code
                </Typography>
              </div>
              <Typography style={{ paddingLeft: "8px" }}>
                <li>
                  You can get the promo code from our{" "}
                  <a
                    href="https://t.me/CoinSpinSaga"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: theme.palette.custom.blue }}
                  >
                    Telegram
                  </a>
                  .
                </li>
                <li>Enter the code in Promo Claim to receive your reward.</li>
                <li>Rewards are credited in your account currency.</li>
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default PromoInfoModal;
